import {z} from 'zod';
import { Brand } from './Brand';
import { b2bCalendar } from './b2bCalendar';

export const Address = z.object({
  id: z.coerce.number(),
  storeLocatorBrands: z.array(Brand),
  b2bCalendar: b2bCalendar,
}).transform(({ id, storeLocatorBrands, b2bCalendar }) => ({
  id,
  storeLocatorBrands,
  b2bCalendar,
  storeLocatorBrandIds: storeLocatorBrands.map(brand => brand.brandId),
}));

export type Address = z.infer<typeof Address>;
